export default __webpack_public_path__ + "static/media/warning--dead-end--g2.c8837f3e.png";